"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styles = __importStar(require("./Search.css"));
const ControlledFilter_1 = __importDefault(require("../filter/ControlledFilter"));
const react_1 = require("react");
const SearchContextType_1 = require("./SearchContextType");
const constants = __importStar(require("./constants"));
const constants_1 = require("../constants");
const MainFilters = (props) => {
    const { config, customFilters, customComponents } = props;
    const { updateAndSearch } = (0, react_1.useContext)(SearchContextType_1.SearchContext);
    const handleFilterChange = (id, value) => {
        updateAndSearch((0, SearchContextType_1.filterUpdater)(id, value), config);
    };
    const handleCustomFilterChange = (id, value) => {
        updateAndSearch((0, SearchContextType_1.customFilterUpdater)(id, value), config);
    };
    const renderGroups = () => {
        // @ts-ignore
        return config[constants.GuiGroups]
            .filter((group) => group[constants.GuiMain])
            .map((group, index) => (React.createElement("div", { key: `ang-search-component-main-group-${index}`, className: `${styles.mainFilter} ${constants_1.ANG_CSS_PREFIX}-main-filter`, "data-test-id": 'main-filter' }, renderFilters(group))));
    };
    const renderFilters = (group) => {
        // @ts-ignore
        return group[constants.GuiProperties].map((item) => {
            const id = item[constants.GuiTarget] || item[constants.GuiRange][constants._id];
            return (React.createElement(ControlledFilter_1.default, { key: id, id: id, property: item, customFilters: customFilters, customComponents: customComponents, onFilterChange: handleFilterChange, onCustomFilterChange: handleCustomFilterChange, "data-test-id": `test-${id}` }));
        });
    };
    return config[constants.GuiGroups] !== undefined ? (React.createElement("div", { className: `${styles.mainFilters} ${constants_1.ANG_CSS_PREFIX}-main-filters`, "data-test-id": 'main-filters' }, renderGroups())) : null;
};
exports.default = MainFilters;
